// src/api/userProfileApi.js
import { CUSTOMER_PROFILE_URL, CUSTOMER_PROFILE_UPDATE_URL } from "../config/apiConfig";

const PROFILE_URL = CUSTOMER_PROFILE_URL;
const UPDATE_PROFILE_URL = CUSTOMER_PROFILE_UPDATE_URL;

// Fetch user profile
export const fetchUserProfile = async (customerId) => {
  const response = await fetch(PROFILE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ customer_id: customerId }),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch profile: ${response.status}`);
  }

  const data = await response.json();
  if (!Array.isArray(data) || data.length === 0) {
    throw new Error("No profile data found");
  }

  return data[0]; // API returns array with one object
};

// Update user profile
export const updateUserProfile = async (profileData) => {
  const response = await fetch(UPDATE_PROFILE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(profileData),
  });

  if (!response.ok) {
    throw new Error(`Failed to update profile: ${response.status}`);
  }

  const result = await response.json();
  return result;
};